module.exports = __webpack_public_path__ + "media/images/dropdown-arrow-fea24aa95449cde75cd275a858790164.svg";